module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/icb/t2c/summary/summary.component.scss
// module id = 899
// module chunks = 10